var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEngine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75.521,
    height: 47.529,
    viewBox: "0 0 75.521 47.529",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10293.162,1696.259h14.064v-8.649h0v8.649h11.606l2.323,4.645h10.635l3.031,5.353h4.9v6.785h6.248V1700.9h5.823v28.85h-5.823v-10.391h-6.248v7.438h-4.9l-3.031,5.338h-32.959l-3.01-5.338h-8.275v-12.695h-8.274v0h8.274v-12.334h5.615Z",
    transform: "translate(-10277.772 -1686.11)",
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngine);
export default __webpack_public_path__ + "static/media/engine.312f6c1697ab13025ab9ca47d6cce359.svg";
export { ForwardRef as ReactComponent };